import { Component, Input, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RowNews } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { NavigationService } from 'src/app/shared/services/navigation.service';

@Component({
  selector: 'app-complete-results',
  templateUrl: './complete-results.component.html',
  styleUrls: ['./complete-results.component.scss']
})
export class CompleteResultsComponent implements OnInit {
  @Input() block: any;
  public items: RowNews[] = [];
  public totalItems: number = 0;
  public page = 0;
  public waitItems = false;
  public imageSrc: string = "";
  public imageAlt: string = "";
  public domainWebsite = environment.urlApi;
  public innerText: string = '';
  public actualRoute: string = '';
  public searchControl: FormControl = new FormControl('');

  constructor(private nodeService: NodeService,
    private helpersService: HelpersService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public navigationService: NavigationService
  ) { }

  ngOnInit(): void {
    this.actualRoute = this.router.url.split('?')[0];
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['search'] !== undefined) {
        this.searchControl.setValue(params['search']);
        this.getResultsPerPage(params['search']);
      } else {
        this.getResultsPerPage();
      }
    });
  }

  public getResultsPerPage($event: string = "") {
    this.innerText = $event;
    this.page = 0;
    this.nodeService.getResultsPerPage(this.helpersService.langCodeApi, this.block.tipo_view, this.page, this.block.preview, this.innerText).subscribe(res => {
      this.items = res.rows;
      this.totalItems = Number(res.pager.total_items);
    }, err => {
      this.nodeService.showError(err);
    })
  }

  public showMore() {
    this.page++;
    this.waitItems = true;
    this.nodeService.getResultsPerPage(this.helpersService.langCodeApi, this.block.tipo_view, this.page, this.block.preview, this.innerText).subscribe(res => {
      this.items = this.items.concat(res.rows);
      this.waitItems = false;
    }, err => {
      this.nodeService.showError(err);
      this.waitItems = false;
    })
  }

}
